// ============================================================
//  CONFIGURACIÓN DE FIREBASE
//  Rellena estos valores con los de tu proyecto en Firebase
//  (Paso 3 de la guía de configuración)
// ============================================================

import { initializeApp } from "firebase/app";
import { getDatabase, ref, set, onValue } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyCj-kDbMUsbuEYg-6DBzvJUCrmf2U_ueGQ",
  authDomain: "alabanza-app-2026.firebaseapp.com",
  databaseURL: "https://alabanza-app-2026-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "alabanza-app-2026",
  storageBucket: "alabanza-app-2026.firebasestorage.app",
  messagingSenderId: "161376660887",
  appId: "1:161376660887:web:2a1881916d300c357468d2"
};

const app = initializeApp(firebaseConfig);
const db = getDatabase(app);

// ── Escucha la canción activa en tiempo real ──────────────────
export function escucharCancionActiva(callback) {
  const cancionRef = ref(db, "cancionActiva");
  return onValue(cancionRef, (snapshot) => {
    callback(snapshot.val());
  });
}

// ── Cambia la canción activa (sincroniza a todos) ─────────────
export function cambiarCancionActiva(cancion) {
  const cancionRef = ref(db, "cancionActiva");
  return set(cancionRef, cancion);
}
